import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatDividerModule } from '@angular/material/divider';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSelectModule } from '@angular/material/select';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'; // Include MatProgressSpinnerModule
import {MatMenuModule} from '@angular/material/menu';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatCheckboxModule} from '@angular/material/checkbox';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter } from '@angular/material/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TimesheetComponent } from './components/timesheet/timesheet.component';
import { TimesheetListComponent } from './components/timesheet-list/timesheet-list.component';
import { LoginComponent } from './components/login/login.component';
import { LayoutComponent } from './components/layout/layout.component';
import { HeaderComponent } from './components/header/header.component';
import { UserComponent } from './components/user/user.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { UserService } from './services/user.service';
import { AuthInterceptor } from './auth.interceptor';
import { UserListComponent } from './components/user-list/user-list.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { ActivityComponent } from './components/activity/activity.component';
import { CategoryComponent } from './components/category/category.component';
import { CategoryListComponent } from './components/category-list/category-list.component';
import { ActivityListComponent } from './components/activity-list/activity-list.component';
import { TimesheetService } from './services/timesheet.service';
import { DatePipe } from '@angular/common';
import { CategoryReportComponent } from './components/reports/category-report/category-report.component';
import { ReportHeaderComponent } from './components/reports/report-header/report-header.component';
import { UserReportComponent } from './components/reports/user-report/user-report.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { AnonymousFeedbackComponent } from './components/anonymous-feedback/anonymous-feedback.component';
import { AnonymousFeedbackListComponent } from './components/anonymous-feedback-list/anonymous-feedback-list.component';
import { RecruitmentComponent } from './components/recruitment/recruitment.component';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from '@danielmoncada/angular-datetime-picker';

@NgModule({
  declarations: [
    AppComponent,
    TimesheetComponent,
    TimesheetListComponent,
    LoginComponent,
    LayoutComponent,
    HeaderComponent,
    UserComponent,
    DashboardComponent,
    UserListComponent,
    ChangePasswordComponent,
    ActivityComponent,
    CategoryComponent,
    CategoryListComponent,
    ActivityListComponent,
    CategoryReportComponent,
    ReportHeaderComponent,
    UserReportComponent,
    AnonymousFeedbackComponent,
    AnonymousFeedbackListComponent,
    RecruitmentComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    RouterModule,
    AppRoutingModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatSnackBarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatTableModule,
    MatIconModule,
    MatPaginatorModule,
    MatDividerModule,
    MatGridListModule,
    MatToolbarModule,
    MatSidenavModule,
    MatSelectModule,
    MatDialogModule,
    MatProgressSpinnerModule, // Include MatProgressSpinnerModule here,
    MatMenuModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatIconModule,
    MatTooltipModule,
    NgxMatSelectSearchModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule
  ],
  providers: [
    DatePipe,
    TimesheetService,
    UserService,
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    { provide: MAT_DATE_FORMATS, useValue: {
      parse: {
        dateInput: 'DD-MM-YYYY',
      },
      display: {
        dateInput: 'DD-MM-YYYY',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'DD-MM-YYYY',
        monthYearA11yLabel: 'MMMM YYYY',
      },
    }},
    { provide: DateAdapter, useClass: MomentDateAdapter },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: MatSnackBarConfig, useValue: { duration: 5000 } } // Add this line
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
